/*=========================================================================================
  File Name: moduleTreatmentsActions.js
  Description: Treatments Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    getTreatments({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/" + payload.id + "/treatments").then((response) => {
                commit("SET_TREATMENTS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    getPatientSideEffects({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/sideeffects/patients/" + payload.patient_id + "/" + payload.treatment_id).then((response) => {
                commit("SET_SIDE_EFFECTS", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    getPatientLaboratoryMonitorings({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/monitorings/patients/" + payload.patient_id + "/" + payload.treatment_id).then((response) => {
                commit("SET_LABORATORY_MONITORINGS", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

}
